import { api } from "@/config/api";
import type { AxiosError } from "axios";
import { CheckoutFailReason } from "ipctg-inflow-types/InFlowEnums";
import type { ParkPayPOSTErrorResponse, ParkPayPOSTRequest, ParkPayPOSTSuccessResponse } from "ipctg-inflow-types/InFlowParkAPI";

export const fetchPay = async (data: ParkPayPOSTRequest): Promise<ParkPayPOSTSuccessResponse> => {
  try {
    const response = await api.post<ParkPayPOSTSuccessResponse>("/pay", data);
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError<ParkPayPOSTErrorResponse>;
    throw axiosError.response?.data ?? { failReason: CheckoutFailReason };
  }
};
